import React from "react";
import { Button, Typography, Box } from "@mui/material";
import { ShieldCross } from "iconsax-react";
import { useAuth } from "../../../auth/useAuth";
const NoAccessPage = () => {
    const { logout } = useAuth();
    const handleLogout = () => {
        logout();
    };
    return (React.createElement(Box, { sx: {
            display: "flex",
            height: "100vh",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "background.default",
        } },
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                maxWidth: "500px",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                gap: 4,
                p: 4,
            } },
            React.createElement(Box, { sx: {
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    bgcolor: "error.lighter",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                } },
                React.createElement(ShieldCross, { size: 64, color: "#D32F2F", variant: "Bold" })),
            React.createElement(Box, { display: "flex", flexDirection: "column", gap: 2 },
                React.createElement(Typography, { variant: "h4", fontWeight: 600, color: "text.primary" }, "Geen Toegang"),
                React.createElement(Typography, { variant: "body1", color: "text.secondary" }, "U bent niet gemachtigd om toegang te krijgen tot deze applicatie. Er zijn geen bedrijven aan uw account toegewezen."),
                React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "Neem contact op met uw systeembeheerder om toegang aan te vragen.")),
            React.createElement(Button, { variant: "contained", color: "primary", size: "large", onClick: handleLogout, sx: { minWidth: "200px" } }, "Uitloggen"))));
};
export default NoAccessPage;
